window.onscroll = function () {
    var elementExists = document.getElementById("myBar");
    if (typeof(elementExists) != 'undefined' && elementExists != null) {
        myFunction()
    }
};


function myFunction() {
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var scrolled = (winScroll / height) * 100;
    document.getElementById("myBar").style.width = scrolled + "%";
}